import React from 'react';
import { motion } from 'framer-motion';
import Timer from './countdown/Timer';
import RotatingPhrases from './countdown/RotatingPhrases';
import DayNightCycle from './countdown/background/DayNightCycle';
import { WEDDING_DATE } from '../config/dates';
import OrnamentCorner from './decorative/OrnamentCorner';

const Countdown = () => {
  return (
    <section className="min-h-[500px] h-[40vh] h-screen relative overflow-hidden">
      <DayNightCycle />

      <div className="relative z-10 h-full flex flex-col items-center justify-center px-4">
        {/* Contenedor con bordes para los ornamentos */}
        <div className="relative border border-white/20 rounded-lg p-8 md:p-12">
          <OrnamentCorner position="top-left" className="opacity-60 -translate-x-4 -translate-y-4" />
          <OrnamentCorner position="top-right" className="opacity-60 translate-x-4 -translate-y-4" />
          <OrnamentCorner position="bottom-left" className="opacity-60 -translate-x-4 translate-y-4" />
          <OrnamentCorner position="bottom-right" className="opacity-60 translate-x-4 translate-y-4" />

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl md:text-4xl font-cursive mb-4 drop-shadow-lg">
              Nos casamos en
            </h2>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4 }}
          >
            <Timer date={WEDDING_DATE} />
          </motion.div>

        </div>
        <RotatingPhrases />
      </div>
    </section>
  );
};

export default Countdown; 